import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	Z_INDEX: {
		OVERLAY: 50,
		SCROLL_TOP: 50,
		NOTIFICATION: 100,
		MODAL: 301,
		DRAWER: 302,
		POPOVER: 302,
		TOOLTIP: 302,
		SELECT: 302,
		CREATOR_LOADING: 303,
		MODEL_VIEWER: 304,
		MODAL_INSTRUCTION: 504,
	},
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	HISTORY_MAX_LENGTH: 10,
	DEFAULT_LANGUAGE: 'PL',
	FILTERABLE_ATTRIBUTE_VALUES_THRESHOLD: 4,
	TEMP_PROJECT_STORAGE_KEY: 'tempProject',
	CURRENCIES: ['PLN', 'EUR', 'CZK', 'GBP', 'CHF', 'USD'],
} as const;

export default APP_CONFIG;
